export default "__VITE_ASSET__BLygdJOT__"